import angular from 'angular';
import ordersComponent from './orders.component';
import OrdersService from './orders.service';
import ordersConfig from './orders.config';

let ordersModule = angular.module('app.reports.orders',[])
  .component('reportOrders', ordersComponent)
  .service('ReportOrdersService', OrdersService)
  .config(ordersConfig);

export default ordersModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/reports/orders/orders.js
 **/